import { defineMessages } from "react-intl";

export const appMessages = defineMessages({
  sidebarAdminWorkspaces: {
    id: "app.sidebar.admin.workspaces",
    defaultMessage: "Workspaces",
  },
  sidebarAdminWorkspacesTable: {
    id: "app.sidebar.admin.workspacesTable",
    defaultMessage: "Workspaces — Table view",
  },
  sidebarAdminWorkforce: {
    id: "app.sidebar.admin.workforce",
    defaultMessage: "Workforce",
  },
  sidebarAdminSubAdmin: {
    id: "app.sidebar.admin.sub.admin",
    defaultMessage: "Admin",
  },
  sidebarAdminSubManager: {
    id: "app.sidebar.admin.sub.manager",
    defaultMessage: "Manager",
  },
  sidebarAdminSubEmployee: {
    id: "app.sidebar.admin.sub.employee",
    defaultMessage: "Employee",
  },
  sidebarAdminSubSubContractor: {
    id: "app.sidebar.admin.sub.subContractor",
    defaultMessage: "Sub-Contractor",
  },
  sidebarAdminCustomers: {
    id: "app.sidebar.admin.customers",
    defaultMessage: "Customers",
  },
  sidebarAdminMaintenance: {
    id: "app.sidebar.admin.maintenance",
    defaultMessage: "Maintenance Window",
  },
  sidebarRoster: {
    id: "app.sidebar.roster",
    defaultMessage: "Roster",
  },
  sidebarProjectRegister: {
    id: "app.sidebar.projectRegister",
    defaultMessage: "Project Register",
  },
  sidebarEstimates: {
    id: "app.sidebar.estimates",
    defaultMessage: "Estimates",
  },
  sidebarProjects: {
    id: "app.sidebar.projects",
    defaultMessage: "Projects",
  },
  sidebarTaskAndClaims: {
    id: "app.sidebar.taskAndClaims",
    defaultMessage: "Task & Claims",
  },
  sidebarWorkforce: {
    id: "app.sidebar.workforce",
    defaultMessage: "Workforce",
  },
  sidebarAdmin: {
    id: "app.sidebar.admin",
    defaultMessage: "Admin",
  },
  sidebarManager: {
    id: "app.sidebar.manager",
    defaultMessage: "Manager",
  },
  sidebarEmployee: {
    id: "app.sidebar.employee",
    defaultMessage: "Employee",
  },
  sidebarSubContractor: {
    id: "app.sidebar.subContractor",
    defaultMessage: "Sub-Contractor",
  },
  sidebarSettings: {
    id: "app.sidebar.settings",
    defaultMessage: "Settings",
  },
  sidebarClients: {
    id: "app.sidebar.clients",
    defaultMessage: "Clients",
  },
  sidebarCustomer: {
    id: "app.sidebar.customer",
    defaultMessage: "Customer",
  },
  sidebarProspect: {
    id: "app.sidebar.prospect",
    defaultMessage: "Prospect",
  },
  sidebarInvoicing: {
    id: "app.sidebar.invoicing",
    defaultMessage: "Invoicing",
  },
  sidebarContractInvoice: {
    id: "app.sidebar.contractInvoice",
    defaultMessage: "Contract Invoice",
  },
  sidebarDocketInvoice: {
    id: "app.sidebar.docketInvoice",
    defaultMessage: "Docket Invoice",
  },
  sidebarXeroInvoice: {
    id: "app.sidebar.xeroInvoice",
    defaultMessage: "Xero Invoice",
  },
  sidebarWasteManage: {
    id: "app.sidebar.wasteManage",
    defaultMessage: "Waste Manage",
  },
  sidebarSummary: {
    id: "app.sidebar.summary",
    defaultMessage: "Summary",
  },
  sidebarRequest: {
    id: "app.sidebar.request",
    defaultMessage: "Request",
  },
  sidebarWeighBridge: {
    id: "app.sidebar.weighBridge",
    defaultMessage: "Weigh Bridge",
  },
  sidebarWeighScale: {
    id: "app.sidebar.weighScale",
    defaultMessage: "Weigh Scale",
  },
  sidebarWeightingReports: {
    id: "app.sidebar.weightingReports",
    defaultMessage: "Weighting Reports",
  },
  sidebarVehicles: {
    id: "app.sidebar.vehicles",
    defaultMessage: "Vehicles",
  },
  sidebarLoadType: {
    id: "app.sidebar.loadType",
    defaultMessage: "Load Type",
  },
  sidebarWasteType: {
    id: "app.sidebar.wasteType",
    defaultMessage: "Waste Type",
  },
  sidebarTippingYard: {
    id: "app.sidebar.tippingYard",
    defaultMessage: "Tipping Yard",
  },
  sidebarReports: {
    id: "app.sidebar.reports",
    defaultMessage: "Reports",
  },
  sidebarProjectDailyReports: {
    id: "app.sidebar.projectDailyReports",
    defaultMessage: "Project Daily Reports",
  },
  sidebarTippingReports: {
    id: "app.sidebar.tippingReports",
    defaultMessage: "Tipping Reports",
  },
  sidebarWorkDocket: {
    id: "app.sidebar.workDocket",
    defaultMessage: "Work Docket",
  },
  sidebarDailyReports: {
    id: "app.sidebar.dailyReports",
    defaultMessage: "Daily Reports",
  },
  sidebarReportQuestions: {
    id: "app.sidebar.reportQuestions",
    defaultMessage: "Report Questions",
  },
  sidebarReportSettings: {
    id: "app.sidebar.reportSettings",
    defaultMessage: "Report Settings",
  },
  sidebarTimeTracking: {
    id: "app.sidebar.timeTracking",
    defaultMessage: "Time Tracking",
  },
  sidebarWorklogs: {
    id: "app.sidebar.worklogs",
    defaultMessage: "Worklogs",
  },
  sidebarIntelliFlow: {
    id: "app.sidebar.intelliFlow",
    defaultMessage: "IntelliFlow",
  },
  sidebarDocumentParser: {
    id: "app.sidebar.documentParser",
    defaultMessage: "Document Parser",
  },
  sidebarWarehousing: {
    id: "app.sidebar.warehousing",
    defaultMessage: "Warehousing",
  },
  sidebarCalendar: {
    id: "app.sidebar.calendar",
    defaultMessage: "Calendar",
  },
  sidebarSupport: {
    id: "app.sidebar.support",
    defaultMessage: "Support",
  },
  sidebarMessage: {
    id: "app.sidebar.message",
    defaultMessage: "Message",
  },
  sidebarItems: {
    id: "app.sidebar.items",
    defaultMessage: "Items",
  },
  sidebarFleetRegister: {
    id: "app.sidebar.fleetRegister",
    defaultMessage: "Fleet Register",
  },
  sidebarTools: {
    id: "app.sidebar.tools",
    defaultMessage: "Tools",
  },
  sidebarProducts: {
    id: "app.sidebar.products",
    defaultMessage: "Products",
  },
  sidebarOhs: {
    id: "app.sidebar.ohs",
    defaultMessage: "OH&S",
  },
  sidebarInduction: {
    id: "app.sidebar.induction",
    defaultMessage: "Induction",
  },
  sidebarSetting: {
    id: "app.sidebar.setting",
    defaultMessage: "Setting",
  },
  sidebarActivity: {
    id: "app.sidebar.activity",
    defaultMessage: "Activity",
  },
  customerSidebarDashboard: {
    id: "app.sidebar.customer.dashboard",
    defaultMessage: "Dashboard",
  },
  customerSidebarUserManagement: {
    id: "app.sidebar.customer.userManagement",
    defaultMessage: "User Management",
  },
  customerSidebarProjects: {
    id: "app.sidebar.customer.projects",
    defaultMessage: "Projects",
  },
  customerSidebarInvoices: {
    id: "app.sidebar.customer.invoices",
    defaultMessage: "Invoices",
  },
  customerSidebarWorkDocket: {
    id: "app.sidebar.customer.workDocket",
    defaultMessage: "Work Docket",
  },
  customerSidebarWasteManagement: {
    id: "app.sidebar.customer.wasteManagement",
    defaultMessage: "Waste Management",
  },
  customerSidebarRequests: {
    id: "app.sidebar.customer.requests",
    defaultMessage: "Requests",
  },
});
